import { lazy } from "react";
import { Navigate } from 'react-router-dom';

export function lazyLoad(importFunc) {
  return lazy(() =>
    importFunc().catch((error) => {
      console.error(error);
      return {
        default: () => <Navigate to="/network-error" replace />
      }
    })
  );
}
